<template>
  <div style="width: 100%; height: 100%">
      <v-row style="width: 100%; height: 100%">
        <v-col fill-height>
          <iframe :src="getFirstDashboard()" frameborder="0" style="width: 100%; height: 100%"></iframe>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col fill-height>
          <iframe :src="getSecondDashboard()" frameborder="0" style="width: 100%; height: 100%"></iframe>
        </v-col>
      </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: mapState({
    smartDisplay: state => state.smartDisplays.smartDisplayList
  }),
  methods: {
    getBoard () {
      if (this.smartDisplay !== undefined) {
        return this.smartDisplay
      }
    },
    getBoardName () {
      return this.getBoard().board.name
    },
    getFirstDashboard () {
      if (this.getBoard().board.dashboards.length >= 1) {
        return this.getBoard().board.dashboards[0].value
      }
    },
    getSecondDashboard () {
      if (this.getBoard().board.dashboards.length >= 2) {
        return this.getBoard().board.dashboards[1].value
      }
    }
  }
}
</script>
